<template>
  <div>
    <el-form
      ref="searchInfo"
      :model="searchInfo"
      class="global-form"
      :inline="true"
    >
      <el-form-item>
        <el-select
          v-model="searchInfo.projectId"
          placeholder="请选择项目"
          filterable
          clearable
        >
          <el-option
            v-for="item in projectList"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchInfo.teamName"
          clearable
          placeholder="请输入班组名称"
        />
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="searchInfo.overtimeDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择加班日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div>
      <!-- <el-button class="mb20" type="primary" @click="onExport" v-show="$ButtonShow('YWK_SEL_10')">
          <div class="importExport">
            <svg class="global-icon" aria-hidden="true">
              <use :xlink:href="'#icon-icon_obj_daochu'"></use>
            </svg>
            <span>导出</span>
          </div>
        </el-button> -->
      <el-button
        class="btn"
        type="primary"
        icon="el-icon-plus"
        @click="onAdd"
        v-show="$ButtonShow('YOC_ADD_02')"
        >新增加班</el-button
      >
    </div>
    <el-table
      ref="table"
      class="global-table"
      stripe
      v-loading="loading"
      :data="tableData"
    >
      <el-table-column
        label="项目名称"
        min-width="100px"
        show-overflow-tooltip
        prop="projectName"
      >
      </el-table-column>
      <el-table-column
        label="工人/班组"
        min-width="100px"
        show-overflow-tooltip
        prop="teamName"
      >
      </el-table-column>
      <el-table-column
        label="加班日期"
        min-width="100px"
        show-overflow-tooltip
        prop="overtimeDate"
      >
      </el-table-column>
      <el-table-column
        label="加班人数(人)"
        min-width="100px"
        show-overflow-tooltip
        prop="overtimeNum"
      >
      </el-table-column>
      <el-table-column
        label="加班时长（小时）"
        min-width="100px"
        show-overflow-tooltip
        prop="overtimeHours"
      >
      </el-table-column>
      <el-table-column
        label="加班总时长（小时）"
        min-width="100px"
        show-overflow-tooltip
        prop="totalOvertimeHours"
      >
      </el-table-column>
      <el-table-column
        label="提报人"
        min-width="100px"
        show-overflow-tooltip
        prop="createUserName"
      >
      </el-table-column>
      <el-table-column
        label="提报时间"
        min-width="100px"
        show-overflow-tooltip
        prop="createTime"
      >
      </el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.overtimeId)"
            >查看</el-button
          >
          <el-button
            type="text"
            @click="onEdit(row.overtimeId)"
            v-show="$ButtonShow('YOC_EDT_01')"
            >编辑</el-button
          >
          <el-button
            type="text"
            @click="onDelete(row.overtimeId)"
            v-show="$ButtonShow('YOC_DEL_01')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <global-pagination
      :total="total"
      :current-page.sync="page"
      :page-size.sync="size"
      @current-change="loadData"
      @size-change="loadData"
    ></global-pagination>
    <Details
      :detailsShow.sync="detailsShow"
      :detailsId.sync="detailsId"
    ></Details>
    <Add :addShow.sync="addShow" :id.sync="id" @success="loadData"></Add>
  </div>
</template>

<script>
import Details from "./ExtraworkListDetails.vue";
import Add from "./ExtraworkListAdd.vue";

// @KeepAlive
export default {
  name: "ExtraworkList",
  components: {
    Details,
    Add,
  },
  data() {
    return {
      searchInfo: {
        projectId: "",
        overtimeDate: "",
        teamName: "",
      },

      total: 0,
      page: 1,
      size: 10,
      loading: false,
      tableData: [],

      addShow: false,

      id: "",
      detailsId: "",
      detailsShow: false,
      // correctId = ''
      correctShow: false,
    };
  },
  computed: {
    projectList() {
      return this.$store.state.projectList;
    },
  },

  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      // console.log('loadData')
      this.loading = true;
      this.$axios
        .get(this.$apis.laborManage.selectOvertimeRecordByPage, {
          ...this.searchInfo,
          page: this.page,
          size: this.size,
        })
        .then((res) => {
          this.tableData = res.list || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSearch() {
      this.page = 1;
      this.loadData();
    },

    onExport() {
      const loading = this.$loading({
        lock: true,
        text: "下载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .downloadFile(
          this.$apis.recruitUse.exportWorkerDutyCount,
          this.searchInfo
        )
        .finally(() => {
          loading.close();
        });
    },

    onDetail(id) {
      this.detailsId = id;
      this.detailsShow = true;
    },

    onEdit(id) {
      this.id = id;
      this.addShow = true;
    },

    // 新增
    onAdd() {
      console.log("新增");
      this.addShow = true;
    },

    // 删除
    onDelete(overtimeId) {
      this.$confirm("确认删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post(this.$apis.laborManage.deleteYhOvertime, { overtimeId })
          .then(() => {
            // this.handleClose()
            this.$message.success("删除成功");
            this.loadData();
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .card-main {
  padding: 0 !important;
}
::v-deep .el-card__body {
  padding: 0 !important;
}
.main {
  width: 100%;
  padding: 20px 40px;
  border-top: 1px solid #f4f4f4;
}
.btn {
  margin-bottom: 10px;
}
</style>
